const I18nKeys = {
    "monitoring.invalid.special.trigger": "O campo \"Tipo de monitoramento especial\" é obrigatório.",
    "user.without.permission": "Você não tem permissão para realizar esta ação.",
    "monitoring.expiring.date.invalid": "O campo \"Data de expiração\" é inválido.",
    "plate.not.supported": "A placa informada não é suportada.",
    "monitoring.invalid.time": "Os campos \"Horário inicial\" e \"Horário final\" devem estar entre 0 e 23.",
    "monitoring.invalid.time.init": "O campo \"Horário inicial\" deve ser menor que o campo \"Horário final\".",
    "monitoring.invalid.output.type": "O campo \"Tipo de saída\" é obrigatório.",
    "monitoring.not.found": "Monitoramento não encontrado.",
    "monitoring.timeInit.range": "O campo \"Horário inicial\" deve estar entre 0 e 23.",
    "monitoring.timeEnd.range": "O campo \"Horário final\" deve estar entre 0 e 23.",
    "monitoring.outputType.required": "O campo \"Tipo de saída\" é obrigatório. (alarme, acompanhamento)",
    "monitoring.specialTriggerDetails.required": "O campo \"Tipo de monitoramento especial\" é obrigatório.",
    "monitoring.daysOfTheWeek.size": "O campo \"Dias da semana\" é obrigatório.",
    "monitoring.lanes.empty": "O campo \"Câmeras\" é obrigatório.",
}

export default I18nKeys;
